// extracted by mini-css-extract-plugin
module.exports = {"card":"Registration_card__7TepF","titleStyle":"Registration_titleStyle__2LQAU","linkStyle":"Registration_linkStyle__2nj5u"};